import { redirectTo } from '../../utils/history';
import { getLink, route } from '../../utils/router';

/**
 * Abre o destino do CTA do home-banner (rota interna ou URL absoluta).
 * @param {string|undefined} ctaLink
 */
export function navigateHomeBannerCta(ctaLink, options) {
  const raw = String(ctaLink || '').trim();
  if (!raw) return;

  if (/^https?:\/\//i.test(raw)) {
    window.location.assign(raw);
    return;
  }

  const path = raw.startsWith('/') ? raw : `/${raw}`;
  try {
    redirectTo(getLink(route(path)), options);
  } catch {
    redirectTo(path, options);
  }
}
